import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      _createElementVNode("path", { d: "M12.084 10.343a.12.12 0 0 0-.062-.104l-3.26-1.784-1.783-3.261c-.042-.076-.166-.076-.207 0L4.989 8.455l-3.26 1.784a.118.118 0 0 0 0 .208l3.26 1.784 1.783 3.261a.118.118 0 0 0 .207 0l1.783-3.261 3.26-1.784a.12.12 0 0 0 .062-.104ZM10.049 4.515l1.936.942 1.058 1.721a.1.1 0 0 0 .082.044.1.1 0 0 0 .082-.044l1.06-1.721 1.935-.942a.08.08 0 0 0 .048-.073.08.08 0 0 0-.048-.073l-1.935-.941-1.06-1.722c-.033-.054-.131-.053-.164 0l-1.058 1.722-1.936.941a.08.08 0 0 0-.048.073c0 .03.018.058.048.073ZM18.282 14.425l-2.379-1.3-1.3-2.38a.1.1 0 0 0-.176 0l-1.301 2.38-2.379 1.3a.1.1 0 0 0 0 .176l2.379 1.301 1.3 2.378a.1.1 0 0 0 .177 0l1.3-2.378 2.379-1.301a.1.1 0 0 0 0-.177Z" })
    ], -1)
  ])))
}
export default { render: render }